export const NEWS_AUTO_OPEN_BLOCKED_PATHS = ['/delivery/cart', '/cashdesk', '/restaurant/cart', '/report']
